/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";
import { useAgentContext } from "../../../../context/agent/AgentContext";
import { Modal, Search, Pagination, MyButton } from "../../component/Component";
import { pushOneAgent } from "../../../../middlewares/sysNavigation/SysNavigation";

const addRoute = "/agent/add";
const editRoute = "/agent/edit";

const Overview = () => {
  const [agentList, setAgentList] = useState([]);
  const { agent, fetchAgents, count } = useAgentContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  useEffect(() => {
    if (!agent) fetchAgents(page, pageSize);
    else setAgentList(agent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agent]);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    if (agent !== null && agent !== undefined)
      agent.map((_agent_) => {
        if (_agent_.name.toString().toLowerCase().includes(key))
          return searchArray.push(_agent_);
        return true;
      });

    setAgentList(searchArray);
    if (key === "") setAgentList(agent);
  };

  return (
    <div className="h-full overflow-y-auto bg-gray-50 p-4 rounded-b-xl">
      <div className="mx-auto max-w-screen-2xl">
        {/* Header / Toolbar */}
        <div className="relative mb-5">
          <div className="pointer-events-none absolute -inset-x-4 -top-6 h-24 rounded-3xl bg-gradient-to-r from-emerald-400/15 via-amber-400/15 to-fuchsia-400/15 blur-2xl -z-10" />
          <div className="relative rounded-2xl border border-gray-200 bg-white/90 shadow-sm backdrop-blur">
            <div className="flex flex-col gap-4 p-4 md:flex-row md:items-center md:justify-between">
              <div className="min-w-0">
                <h1 className="truncate text-base font-semibold tracking-tight text-gray-900">
                  Agents Directory
                </h1>
                <div className="mt-2 flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center gap-2 rounded-full bg-gray-100 px-2.5 py-1 text-[11px] font-medium text-gray-700 ring-1 ring-gray-200">
                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                    Total agents:
                    <span className="ml-1 font-semibold text-gray-900">
                      {count || 0}
                    </span>
                  </span>
                </div>
              </div>

              <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:items-center">
                {/* Search (keeps your component; we just place it neatly) */}
                <div className="sm:w-72">
                  <Search
                    props={{
                      title: "Agent",
                      onChange: (e) => SearchList(e),
                    }}
                  />
                </div>

                <Link to={addRoute} className="sm:ml-2">
                  <MyButton
                    title="Add Agent"
                    className="rounded-lg bg-gradient-to-br from-gray-800 to-gray-700 hover:from-gray-900 hover:to-gray-800 px-4 py-2 text-xs font-semibold"
                    onClick={() => { }}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Table card */}
        <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="relative max-h-[60vh] overflow-auto">
            <table className="min-w-full text-sm">
              <thead className="sticky top-0 z-10 bg-white/90 backdrop-blur">
                <tr className="text-left text-xs uppercase tracking-wide text-gray-500">
                  <th className="px-4 py-3 font-semibold">Name</th>
                  <th className="px-4 py-3 font-semibold">Biz. Reg. No.</th>
                  <th className="px-4 py-3 font-semibold">Date Of Joining</th>
                  <th className="px-4 py-3 font-semibold text-center">Manage</th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {agent ? (
                  agentList.map((agt) => {
                    const date = new Date(agt?.createdAt);
                    const joinDate =
                      date.getFullYear() +
                      "-" +
                      date.getMonth().toString().padStart(2, "0") +
                      "-" +
                      date.getDate().toString().padStart(2, "0");

                    return (
                      <tr
                        key={agt?.dsa_agents_id}
                        className="hover:bg-gray-50/60 transition-colors"
                      >
                        <td className="px-4 py-3 align-middle">
                          <div className="flex items-center gap-3">
                            <div className="grid h-8 w-8 place-items-center rounded-lg bg-gray-900 text-white text-[10px] font-bold shadow-sm">
                              {agt?.name?.slice(0, 2)?.toUpperCase() || "AG"}
                            </div>
                            <div className="min-w-0">
                              <div className="truncate font-semibold text-gray-900">
                                {agt?.name}
                              </div>
                              <div className="truncate text-[11px] text-gray-500">
                                Agent
                              </div>
                            </div>
                          </div>
                        </td>

                        <td className="px-4 py-3 align-middle text-gray-700">
                          <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-[11px] font-medium text-gray-700 ring-1 ring-gray-200">
                            {agt?.agent_biz_reg_no || "-"}
                          </span>
                        </td>

                        <td className="px-4 py-3 align-middle text-gray-700">
                          <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-[11px] font-medium text-gray-700 ring-1 ring-gray-200">
                            {joinDate}
                          </span>
                        </td>

                        <td className="px-4 py-3 align-middle">
                          <div className="flex justify-center">
                            <ActionButton props={agt} />
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      className="px-4 py-6 text-center text-gray-500"
                      colSpan={4}
                    >
                      Loading agents…
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Single bottom pagination */}
          <div className="border-t border-gray-100 px-4 py-3">
            <div className="flex items-center justify-end">
              <Pagination
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                total_items={count}
                callbackFunction={(_page_, _pageSize_) => {
                  fetchAgents(_page_, _pageSize_);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props }) => {
  const { agent, updateAgentState, deleteAgent } = useAgentContext();

  const [showModal, setShowModal] = useState(false);

  const dsa_agents_id = props.dsa_agents_id;
  const agent_name = props.name;
  const _agent_ = props;

  const deleteOneAgentById = async (dsa_agents_id) => {
    const response = await deleteAgent(dsa_agents_id);
    if (response.data.status === 200) {
      if (agent) {
        updateAgentState(
          agent.filter((_agent_) => _agent_.dsa_agents_id !== dsa_agents_id)
        );
        setShowModal(false);
      }
    }
  };

  return (
    <>
      <Modal
        props={{
          name: agent_name,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneAgentById(dsa_agents_id),
        }}
      />

      <div
        className={[
          "inline-flex w-full max-w-[520px] flex-wrap items-center justify-center gap-2",
          "rounded-xl border border-gray-200 bg-white/70 px-3 py-2 shadow-sm",
        ].join(" ")}
      >
        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className="rounded-lg bg-gradient-to-br from-blue-700 to-blue-600 hover:from-blue-800 hover:to-blue-700 px-3 py-2 text-xs font-semibold"
            onClick={() => pushOneAgent(_agent_)}
          />
        </Link>
        <MyButton
          title="Delete"
          className="rounded-lg bg-gradient-to-br from-red-700 to-red-600 hover:from-red-800 hover:to-red-700 px-3 py-2 text-xs font-semibold"
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

export default Overview;
